export default "__VITE_ASSET__BaHbhBsX__"